import React from "react";
import "./About.css";

const CenteredContent = () => {
  return (

    <section id= "about-section">

    <div className="background-container">
      <div className="aboutcontent">
        <h2>Who We Are</h2>
        <p>
          At Omega Review Solutions Pvt Ltd, we are redefining excellence in medical coding. 
          Established with a vision to revolutionize coding practices, our team of seasoned 
          professionals is committed to delivering exceptional solutions that empower healthcare 
          providers to streamline their documentation and optimize revenue cycles. With unparalleled 
          expertise, strict compliance adherence, and an unwavering focus on quality, we take pride 
          in being a trusted partner to the healthcare industry.
        </p>
      </div>
    </div>
    </section>
  );
  
};


export default CenteredContent;
